<div class="tisco-consent-modal" *ngIf="data.url">
  <div class="tisco-consent-body">
    <iframe id="iframe" [src]="data.safeUrl" style="border: none;width: 100%;height: 100%;overflow: hidden;" frameborder="0" embedded="true"></iframe>
  </div>
</div>